import React from 'react'
import { useParams } from 'react-router-dom'

import { Flow } from '../../../../containers/Flow'
import './FlowBuilder.overrides.scss'

import { useGetBotProfileQuery } from 'Services/bot-profiles'
import PageLoader from 'Layout/PageLoader'

const FlowBuilder = () => {
  const params = useParams()
  const botId = params.botId

  const { data: botProfile } = useGetBotProfileQuery(botId)

  if (!botProfile) {
    return <PageLoader />
  }

  return <Flow container='newDesign' botProfile={botProfile} />
}

export default FlowBuilder
